import React from "react"

import { Grid, Header } from "semantic-ui-react"
import { Link } from "gatsby"

export default ({ isMobile }) => {
  return (
    <Grid
      stackable
      style={{ backgroundColor: "#0D0D0D", padding: isMobile ? "0em" : "2em" }}
    >
      <Grid.Row centered>
        <Grid.Column textAlign={"center"} width={10}>
          <Header
            inverted
            size={"huge"}
            content={
              "Digitizing your art collection allows you to access it anywhere around the world."
            }
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered columns={1}>
        <Grid.Column textAlign={"center"}>
          <Header
            as={Link}
            style={{ color: "#DFBD9A" }}
            to={"/blog/benefits-of-cataloging/"}
            content={
              "Learn the benefits of documenting your collection online →"
            }
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}
